import {
  MenuItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React from "react";
import {
  AppBar,
  Logout,
  UserMenu,
  useGetIdentity,
  useUserMenu,
  ToggleThemeButton,
  LoadingIndicator,
} from "react-admin";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import icons from "../../styles/icons/icons";
import Clock from "./clock";
import { ListUpdateNotification } from "./list-update-notification";
const { REACT_APP_AUTH_URL, REACT_APP_AUTH_REALM, REACT_APP_AUTH_CLIENT_ID } =
  process.env;

export const GybAppBar = () => {
  const {
    setBranch,
    setBranchId,
    setIsGroupAdmin,
    setIsOrgAdmin,
    setIsScheduler,
    setIsSchAdmin,
  } = React.useContext(UserContext);
  const { identity } = useGetIdentity();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (identity) {
      setBranch(identity.branch);
      setBranchId(identity.branchId);
      setIsGroupAdmin(identity.isGroupAdmin);
      setIsOrgAdmin(identity.isOrgAdmin);
      setIsScheduler(identity.isScheduler);
      setIsSchAdmin(identity.isSchAdmin);
    }
  }, [identity, setBranch, setBranchId]);

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <AppBar
      toolbar={
        <>
          <IconButton edge="start" color="inherit" onClick={handleBackClick}>
            <ArrowBackIcon />
          </IconButton>
          <Clock />
          <ToggleThemeButton />
          <ListUpdateNotification />
          <LoadingIndicator />
        </>
      }
      userMenu={
        <UserMenu>
          <SettingsMenuItem />
          <Logout />
        </UserMenu>
      }
      color="primary"
      position="fixed"
    />
  );
};

const SettingsMenuItem = React.forwardRef((props, ref) => {
  const { onClose } = useUserMenu();
  const { branch } = React.useContext(UserContext);

  const handleAccountManagementClick = () => {
    onClose();
    window.location.href = `${REACT_APP_AUTH_URL}/realms/${REACT_APP_AUTH_REALM}/${REACT_APP_AUTH_CLIENT_ID}/`;
  };

  return (
    <>
      <MenuItem
        onClick={onClose}
        ref={ref as React.RefObject<HTMLLIElement>}
        {...props}
      >
        <ListItemIcon>
          <icons.group fontSize="small" />
        </ListItemIcon>
        <ListItemText>{branch}</ListItemText>
      </MenuItem>
      <MenuItem onClick={handleAccountManagementClick}>
        <ListItemIcon>
          <icons.accountCircle fontSize="small" />
        </ListItemIcon>
        <ListItemText>账号管理</ListItemText>
      </MenuItem>
    </>
  );
});
